import { Seo, Ticker, TrustBar } from '@/components/primitives'
import { Hero } from '@/sections/home/Hero'
import { ScaleFlex } from '@/sections/home/ScaleFlex'
import { FiveModules } from '@/sections/home/FiveModules'
import { OperatingChain } from '@/sections/home/OperatingChain'
import { ConnectedProof } from '@/sections/home/ConnectedProof'
import { WhoFor } from '@/sections/home/WhoFor'
import { TrustSection } from '@/sections/home/TrustSection'
import { NexTeaser } from '@/sections/home/NexTeaser'
import { FinalCta } from '@/sections/home/FinalCta'

/**
 * Commercial message house (see docs/superpowers/specs/2026-07-19-commercial-messaging-system-design.md)
 * Hero → scale flex → trust → five modules → chain → proof → who-for → governance → Nex → close
 */
export default function Home() {
  return (
    <>
      <Seo
        title="TLDNXS | Customer Operations Platform"
        description="Make the whole operation visible. Over 145,000,000 policies processed on the TLD stack. Book a walkthrough."
      />

      <Hero />
      <ScaleFlex />
      <TrustBar />
      <Ticker />

      <FiveModules />
      <OperatingChain />
      <ConnectedProof />
      <WhoFor />
      <TrustSection />
      <NexTeaser />
      <FinalCta />
    </>
  )
}
